export enum PriceModifierType {
  ADD = 'add',
  MULTIPLY = 'multiply',
}

export const FreePriceItem = 'free';

export type Modifier = {
  type: PriceModifierType;
  value: number;
};

export enum CreditsPriceItem {
  imageGenerationPrice = 'image_generation_price',
  audioGenerationPrice = 'audio_generation_price',
  videoGenerationPrice = 'video_generation_price',
  studioVideo = 'studio_video',
}

class CreditsBillingService {
  private static readonly price = {
    [CreditsPriceItem.imageGenerationPrice]: 1,
    [CreditsPriceItem.audioGenerationPrice]: 1,
    [CreditsPriceItem.videoGenerationPrice]: 5,
    [CreditsPriceItem.studioVideo]: 4,
  };

  public readonly PriceItem = CreditsPriceItem;

  getAmount(priceItems: CreditsPriceItem[], modifiers?: Modifier[]): number {
    return priceItems.reduce((acc, priceItem) => {
      const price = CreditsBillingService.price[priceItem];

      const modifiedPrice = modifiers?.reduce((acc, modifier) => {
        if (modifier.type === PriceModifierType.ADD) {
          return acc + modifier.value;
        }

        if (modifier.type === PriceModifierType.MULTIPLY) {
          return acc * modifier.value;
        }

        return acc;
      }, price);

      return acc + (modifiedPrice || price);
    }, 0);
  }
}

export const creditsBillingService = new CreditsBillingService();
